import { FC, useCallback, useEffect, useState } from "react";

import { InputComponentProps } from "../input";
import TextBox from "../textBox";
import { InputMode, InputType } from "../textBox/types";

export interface Props extends InputComponentProps<any, any> {
	defaultType?: InputType;
	inputMode?: InputMode;
	mask?: string;
	required?: boolean;
	clear?: () => void;
}

export const SecretInput: FC<Props> = (props: Props) => {
	const { value, defaultType = "text", mask, onUnfocused } = props;
	const [type, setType] = useState<InputType>(defaultType);

	useEffect(() => {
		if (value) {
			setType("password");
		}
	}, []);

	useEffect(() => {
		if (!value) {
			setType(defaultType);
		}
	}, [value]);

	const handleOnBlur = useCallback(() => {
		onUnfocused?.();
		if (value && type === defaultType) {
			setType("password");
		}
	}, [value, type, defaultType, onUnfocused]);

	return <TextBox {...props} maskOptions={{ mask }} type={type} onUnfocused={handleOnBlur} />;
};
